function handleNameChange(name) {
	if (typeof name !== "string" || name.length === 0) {
		return "";
	}

	// Initially we will clean the name
	name = name
		.replace(/\s+/g, " ") // Remove mutiple space
		.trim();

	// Convert to Proper Case
	return name
	    .toLowerCase()
		.split(" ")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ");
}

export { handleNameChange };
